function normTitle(s) {
    return s.trim().toLowerCase().replace(/\s+/g, ' ');
}
/**
 * Spanish display names for agency rows when the Flow grid only returns English `NAME`.
 * Prefer `recordId` keys (stable); optionally add exact English titles (normalized).
 *
 * Add entries as you discover them from the agencies grid — there is no automatic translation.
 */
const AGENCY_LABEL_ES_BY_RECORD_ID = {
// Example: '12': 'Licencias y cumplimiento — Salud',
};
const AGENCY_LABEL_ES_BY_ENGLISH_NAME = {
// normTitle('Alcohol Beverage Control') -> '…'
};
/**
 * Display name for the landing hero agencies list (grid API).
 */
export function translateLandingAgencyDisplayName(item, locale) {
    if (locale !== 'es')
        return item.name;
    const id = item.recordId?.trim();
    if (id && AGENCY_LABEL_ES_BY_RECORD_ID[id])
        return AGENCY_LABEL_ES_BY_RECORD_ID[id];
    const byName = AGENCY_LABEL_ES_BY_ENGLISH_NAME[normTitle(item.name)];
    if (byName)
        return byName;
    return item.name;
}
